// @core/api/endpoints/calendar/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AddCalendarMember } from './add_calendar_member';
import { BookSlot } from './book_slot';
import { CancelEntitySchedule } from './cancel_entity_schedule';
import { CancelEvent } from './cancel_event';
import { CheckEntityAvailability } from './check_entity_availability';
import { CreateBookingLink } from './create_booking_link';
import { CreateCalendar } from './create_calendar';
import { CreateCalendarPolicy } from './create_calendar_policy';
import { CreateEvent } from './create_event';
import { CreateEventFromTemplate } from './create_event_from_template';
import { CreateEventTemplate } from './create_event_template';
import { CreateRecurringEvent } from './create_recurring_event';
import { DeleteBookingLink } from './delete_booking_link';
import { DeleteCalendar } from './delete_calendar';
import { DeleteCalendarEventType } from './delete_calendar_event_type';
import { DeleteCalendarPolicy } from './delete_calendar_policy';
import { DeleteEvent } from './delete_event';
import { DeleteEventTemplate } from './delete_event_template';
import { DeleteRecurringEventOccurrence } from './delete_recurring_event_occurrence';
import { DuplicateEvent } from './duplicate_event';
import { ExportCalendar } from './export_calendar';
import { FindAvailableSlots } from './find_available_slots';
import { GetBookingLink } from './get_booking_link';
import { GetBookingLinkAvailability } from './get_booking_link_availability';
import { GetCalendar } from './get_calendar';
import { GetCalendarEventType } from './get_calendar_event_type';
import { GetCalendarPolicy } from './get_calendar_policy';
import { GetCalendarPolicyByEntity } from './get_calendar_policy_by_entity';
import { GetEvent } from './get_event';
import { GetEventTemplate } from './get_event_template';
import { GetFreeBusy } from './get_free_busy';
import { GetRecurringEventInstances } from './get_recurring_event_instances';
import { GetWorkingHours } from './get_working_hours';
import { ImportCalendar } from './import_calendar';
import { InviteAttendees } from './invite_attendees';
import { ListBookingLinks } from './list_booking_links';
import { ListCalendarEventTypes } from './list_calendar_event_types';
import { ListCalendarMembers } from './list_calendar_members';
import { ListCalendarPolicies } from './list_calendar_policies';
import { ListCalendars } from './list_calendars';
import { ListEntitySchedule } from './list_entity_schedule';
import { ListEventTemplates } from './list_event_templates';
import { ListEvents } from './list_events';
import { ListMyEvents } from './list_my_events';
import { MoveEvent } from './move_event';
import { ProposeNewTime } from './propose_new_time';
import { RegisterCalendarEventType } from './register_calendar_event_type';
import { RemoveAttendee } from './remove_attendee';
import { RemoveCalendarMember } from './remove_calendar_member';
import { RescheduleEntity } from './reschedule_entity';
import { ResolveCalendarContext } from './resolve_calendar_context';
import { RespondToInvitation } from './respond_to_invitation';
import { RestoreEvent } from './restore_event';
import { ScheduleEntity } from './schedule_entity';
import { SetWorkingHours } from './set_working_hours';
import { UpdateBookingLink } from './update_booking_link';
import { UpdateCalendar } from './update_calendar';
import { UpdateCalendarEventType } from './update_calendar_event_type';
import { UpdateCalendarMemberRole } from './update_calendar_member_role';
import { UpdateCalendarPolicy } from './update_calendar_policy';
import { UpdateEvent } from './update_event';
import { UpdateEventTemplate } from './update_event_template';
import { UpdateRecurringEvent } from './update_recurring_event';

// Re-export individual endpoints
export {
  AddCalendarMember,
  BookSlot,
  CancelEntitySchedule,
  CancelEvent,
  CheckEntityAvailability,
  CreateBookingLink,
  CreateCalendar,
  CreateCalendarPolicy,
  CreateEvent,
  CreateEventFromTemplate,
  CreateEventTemplate,
  CreateRecurringEvent,
  DeleteBookingLink,
  DeleteCalendar,
  DeleteCalendarEventType,
  DeleteCalendarPolicy,
  DeleteEvent,
  DeleteEventTemplate,
  DeleteRecurringEventOccurrence,
  DuplicateEvent,
  ExportCalendar,
  FindAvailableSlots,
  GetBookingLink,
  GetBookingLinkAvailability,
  GetCalendar,
  GetCalendarEventType,
  GetCalendarPolicy,
  GetCalendarPolicyByEntity,
  GetEvent,
  GetEventTemplate,
  GetFreeBusy,
  GetRecurringEventInstances,
  GetWorkingHours,
  ImportCalendar,
  InviteAttendees,
  ListBookingLinks,
  ListCalendarEventTypes,
  ListCalendarMembers,
  ListCalendarPolicies,
  ListCalendars,
  ListEntitySchedule,
  ListEventTemplates,
  ListEvents,
  ListMyEvents,
  MoveEvent,
  ProposeNewTime,
  RegisterCalendarEventType,
  RemoveAttendee,
  RemoveCalendarMember,
  RescheduleEntity,
  ResolveCalendarContext,
  RespondToInvitation,
  RestoreEvent,
  ScheduleEntity,
  SetWorkingHours,
  UpdateBookingLink,
  UpdateCalendar,
  UpdateCalendarEventType,
  UpdateCalendarMemberRole,
  UpdateCalendarPolicy,
  UpdateEvent,
  UpdateEventTemplate,
  UpdateRecurringEvent,
};

// Namespace export for convenient usage
export const calendarApi = {
  AddCalendarMember,
  BookSlot,
  CancelEntitySchedule,
  CancelEvent,
  CheckEntityAvailability,
  CreateBookingLink,
  CreateCalendar,
  CreateCalendarPolicy,
  CreateEvent,
  CreateEventFromTemplate,
  CreateEventTemplate,
  CreateRecurringEvent,
  DeleteBookingLink,
  DeleteCalendar,
  DeleteCalendarEventType,
  DeleteCalendarPolicy,
  DeleteEvent,
  DeleteEventTemplate,
  DeleteRecurringEventOccurrence,
  DuplicateEvent,
  ExportCalendar,
  FindAvailableSlots,
  GetBookingLink,
  GetBookingLinkAvailability,
  GetCalendar,
  GetCalendarEventType,
  GetCalendarPolicy,
  GetCalendarPolicyByEntity,
  GetEvent,
  GetEventTemplate,
  GetFreeBusy,
  GetRecurringEventInstances,
  GetWorkingHours,
  ImportCalendar,
  InviteAttendees,
  ListBookingLinks,
  ListCalendarEventTypes,
  ListCalendarMembers,
  ListCalendarPolicies,
  ListCalendars,
  ListEntitySchedule,
  ListEventTemplates,
  ListEvents,
  ListMyEvents,
  MoveEvent,
  ProposeNewTime,
  RegisterCalendarEventType,
  RemoveAttendee,
  RemoveCalendarMember,
  RescheduleEntity,
  ResolveCalendarContext,
  RespondToInvitation,
  RestoreEvent,
  ScheduleEntity,
  SetWorkingHours,
  UpdateBookingLink,
  UpdateCalendar,
  UpdateCalendarEventType,
  UpdateCalendarMemberRole,
  UpdateCalendarPolicy,
  UpdateEvent,
  UpdateEventTemplate,
  UpdateRecurringEvent,
};
